module.exports = __webpack_public_path__ + "static/media/video-01.82d8f905.mp4";